import { FilterGroup } from './ScimFilterBuilder';

/**
 * Generate SCIM filter string from a filter group structure
 */
export const generateScimFilter = (group: FilterGroup): string => {
    const parts: string[] = [];

    // Add conditions (use API-style attribute name: no $. prefix)
    group.conditions.forEach(condition => {
        const fieldName = condition.field?.startsWith('$.') ? condition.field.slice(2) : condition.field;
        let conditionStr = '';

        if (condition.function) {
            conditionStr = `${condition.function}(${fieldName})`;
        } else {
            conditionStr = fieldName;
        }

        if (condition.operator === 'pr') {
            parts.push(`${conditionStr} pr`);
        } else if (condition.operator === 'npr') {
            parts.push(`not (${conditionStr} pr)`);
        } else if (condition.operator === '$in') {
            // Handle $in operator specially - it should be: field $in ["value1", "value2"]
            // Parse comma-separated values and format as array
            const values = condition.value.split(',').map(v => v.trim()).filter(v => v);
            if (values.length === 0) {
                // Invalid - no values, skip this condition
                return;
            }
            // Format as array: ["value1", "value2"]
            const valueArray = values.map(v => `"${v}"`).join(', ');
            parts.push(`${conditionStr} $in [${valueArray}]`);
        } else {
            // Handle different value types
            let value = condition.value;
            if (fieldName === 'entityType' || fieldName === 'type' || fieldName === 'scope') {
                value = `"${condition.value}"`;
            } else {
                value = `"${condition.value}"`;
            }
            parts.push(`${conditionStr} ${condition.operator} ${value}`);
        }
    });

    // Add sub-groups
    group.groups.forEach(subGroup => {
        const subGroupFilter = generateScimFilter(subGroup);
        if (subGroupFilter) {
            parts.push(`(${subGroupFilter})`);
        }
    });

    return parts.join(` ${group.operator} `);
}; 